<p-dialog [visible]="isLoading" [modal]="true" [closable]="false" [closeOnEscape]="false" [draggable]="false"
          [resizable]="false">
  <div class="text-center">
    <i class="pi pi-spin pi-spinner text-amber-500" style="font-size: 2rem"></i>
    <p class="text-gray-600 mt-4">Carregando</p>
  </div>
</p-dialog>
